<template>
  <div class="fccFotoUser">
    <img
      :src="
        documentoUser.usuariocomplemento.usucompfoto == null ||
        documentoUser.usuariocomplemento.usucompfoto === ''
          ? userIcon
          : documentoUser.usuariocomplemento.usucompfoto
      "
      class="user"
      alt="Foto"
    />
    <b-form-file
      ref="input-candidato"
      v-model="file1"
      placeholder="Escolha um arquivo..."
      @input="EnviarArquivo()"
      plain
      :accept="extPermitido.join()"
    ></b-form-file>
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import './assets/scss/fccFotoUser.scss'
export default {
  name: 'fcc-foto-user',
  data() {
    return {
      baseFile: store.state.baseUrlSga,
      baseUrlSeguranca: this.$fccStore.state.baseUrlSeguranca,
      file1: [],
      userIcon: require('./assets/img/user-icon.svg'),
      porcentagemUpload: 0,
      fotoCandidato: []
    }
  },
  props: {
    documento: String,
    codArqCad: {
      type: String,
      default: 'FTU'
    },
    usuario: {
      type: Object,
      default: () => {}
    },
    tipoUser: {
      type: String,
      default: 'Candidato'
    },
    extPermitido: {
      type: Array,
      default: () => ['image/png', 'image/jpg', 'image/jpeg']
    }
  },
  methods: {
    editandoUsuario: function (urlVideo) {
      this.usuario.usuariocomplemento.usucompfoto = urlVideo
      delete this.usuario.ususenha
      this.carregaTexto(this.codeMensagem('C05'))
      axios
        .put(
          this.baseUrlSeguranca + 'Cadastro/alterarlogin',
          this.usuario,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.carregaTexto()
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    async EnviarArquivo() {
      this.carregaTexto(this.codeMensagem('C01'))
      if (this.file1 !== null) {
        if (!this.extPermitido.find((element) => element === this.file1.type)) {
          this.callAlert(
            'O arquivo deve estar num dos formatos permitidos!',
            this.file1.name,
            'error',
            'error'
          )
        } else {
          var documento = this.usuario.usuariocomplemento.usucompdocto
          documento = this.removeAcento(documento)
          await this.DeleteArquivoGenerico(
            this.codArqCad,
            this.removeAcento(this.usuario.usuariocomplemento.usucompdocto)
          )
          setTimeout(() => {
            const arquivoForm = new FormData()
            let parametros = 'ArqcadCod=' + this.codArqCad
            parametros += '&ArqIDExterno=' + documento
            parametros += '&ArqPublico=true'
            arquivoForm.append('file', this.file1)
            this.carregaTexto('Enviando...')
            axios
              .post(this.baseFile + 'File/Upfile?' + parametros, arquivoForm, {
                headers: this.dadosLoginSession.fccTokenHeaders.headers
              })
              .then((response) => {
                this.editandoUsuario(response.data.arqurl)
              })
          }, 2000)
        }
      }
    }
  },
  computed: {
    documentoUser: function () {
      return this.usuario
    }
  }
}
</script>
